import React, { useState, useEffect } from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import UndoOutlinedIcon from '@mui/icons-material/UndoOutlined';
import { PieChart } from '@mui/x-charts/PieChart';
import PieChartLegend from './pieChartLegend';

function PortfolioPieChart({ id, watchlist, holdings, setCurrentStock, setWatchlistStock, handleRemoveFromWL, demoState, demo, increaseDemoState }) {
    const [positions, setPositions] = useState([]);
    const [watchlistData, setWatchlistData] = useState([]);
    const [itemData, setItemData] = useState(null);
    const [hoverWL, setHoverWL] = useState(null);
    const [hoverHoldings, setHoverHoldings] = useState(null);

    useEffect(() => {
        const watchlistInfo = Array.isArray(watchlist)
            ? watchlist.length === 1
                ? [{ label: watchlist[0], title: watchlist[0], value: 1, color: generateCoolColor() }]
                : watchlist.map((stock, ind) => ({
                    label: stock,
                    title: stock,
                    value: 1 / watchlist.length,
                    color: generateCoolColor()
                }))
            : [{ label: watchlist.name, title: watchlist.name, value: 1, color: generateCoolColor() }];
        const holdingsRatios = Array.isArray(holdings)
            ? holdings.length === 1
                ? 1
                : holdings.map(x => x.cost * x.shares / holdings.reduce((sum, item) => {
                    return sum + item.cost * item.shares;
                }, 0))
            : 1;
        const holdingsData = Array.isArray(holdings)
            ? holdings.length === 1
                ? [{ label: holdings[0].ticker, ticker: holdings[0].ticker, value: 1, color: generateColor(), shares: holdings[0].shares, cost: holdings[0].cost }]
                : holdings.map((stock, ind) => ({
                    label: stock.ticker,
                    ticker: stock.ticker,
                    value: holdingsRatios[ind],
                    shares: stock.shares,
                    cost: stock.cost,
                    color: generateColor()
                }))
            : [{ label: holdings[0].ticker, ticker: holdings[0].ticker, value: 1, color: generateColor(), shares: holdings[0].shares, cost: holdings[0].cost }];
        setPositions(holdingsData);
        setWatchlistData(watchlistInfo); // Example inner data
    }, [watchlist]);


    // const generateColor = () => `#${Math.floor(Math.random() * 16777215).toString(16)}`;

    // const generateColor = () => {
    //     const baseHue = 32; // Approximate hue of #cc8f2d
    //     return [
    //         `hsl(${(baseHue + 180) % 360}, 70%, 50%)`,  // Complementary color
    //         `hsl(${(baseHue + 30) % 360}, 70%, 50%)`,   // Analogous color (slightly redder)
    //         `hsl(${(baseHue - 30) % 360}, 70%, 50%)`,   // Analogous color (slightly yellower)
    //         `hsl(${(baseHue + 90) % 360}, 70%, 50%)`,   // Split-complementary
    //     ];
    // };
    // const randomWarmColor = () => {
    //     const hue = Math.floor(Math.random() * 40) + 20; // Warm tones (~30-60 range)
    //     return `hsl(${hue}, 70%, ${Math.random() * 30 + 50}%)`; // Adjust lightness
    //   };

    // const generateColor = () => {
    //     const hue = Math.floor(Math.random() * 40) + 20; // Warm tones (~30-60 range)
    //     return `hsl(${hue}, 70%, ${Math.random() * 20 + 20}%)`; // Adjust lightness
    // };


    const generateColor = () => {
        // Choose a metallic hue range: gold, silver, bronze, steel
        const metallicHues = [45, 0, 30, 210]; // gold, chrome, bronze, steel-blue
        const hue = metallicHues[Math.floor(Math.random() * metallicHues.length)];

        const saturation = Math.floor(Math.random() * 10) + 30; // low saturation for muted tones
        const lightness = Math.floor(Math.random() * 30) + 50; // mid-to-high lightness

        return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    };

    const generateCoolColor = () => {
        const hue = Math.floor(Math.random() * 120) + 180; // Cool colors ~180-300 range
        return `hsl(${hue}, 70%, ${Math.random() * 20 + 20}%)`; // Adjust lightness
    };

    // const generateColor = (index, total) => {
    //     const hue = (index * (360 / total)) % 360; // Spread colors evenly across the spectrum
    //     return `hsl(${hue}, 70%, 50%)`; // Adjust saturation & lightness for a consistent look
    // };

    // const generateColor2 = (index, total) => {
    //     const hue = (index * (360 / total)) % 360; // Spread colors evenly across the spectrum
    //     return `hsl(${hue}, 50%, 50%)`; // Adjust saturation & lightness for a consistent look
    // };


    const valueFormatter = (item) => item.cost ? `${item.shares} @ ${item.cost}` : ``;

    const outerSeries = {
        innerRadius: 90,
        outerRadius: 120,
        id: 'outer-series',
        data: watchlistData.map((item, index) => ({
            ...item,
            color: hoverWL === index ? "#fff" : item.color,
        })),
        valueFormatter,
    };

    const innerSeries = {
        innerRadius: 0,
        outerRadius: 80,
        id: 'inner-series',
        data: positions.map((item, index) => ({
            ...item,
            color: hoverHoldings === index ? "#fff" : item.color,
        })),
        valueFormatter,
    };

    const series = [outerSeries, innerSeries];
    return (
        // <Stack
        //     direction={{ xs: 'column', md: 'row' }}
        //     spacing={{ xs: 0, md: 4 }}
        //     sx={{ width: '100%' }}
        // >
        <Box sx={{ fill: "white", display: 'flex', justifyContent: 'flex-start', marginLeft: '-100px', overflow: 'hidden' }}>
            <PieChart
                series={series}
                width={"600"} // I am purposefully making this value invalid since the flex kit sizing is better and with errors the flex kit takes over and corrects sizing
                height={"400"}
                slotProps={{
                    legend: {
                        hidden: true,
                        labelStyle: {
                            fill: "white",
                        },
                    },
                }}
                onItemClick={(event, d) => d.seriesId == 'inner-series' ? setCurrentStock({ id: id, currentStock: positions[d.dataIndex] }) : setWatchlistStock({ id: id, currentStock: watchlist[d.dataIndex] })}
            />
            <PieChartLegend id={id} outerData={watchlistData} innerData={positions} setHoveredOuterIndex={setHoverWL} setHoveredInnerIndex={setHoverHoldings} onClickLeftWL={setWatchlistStock} onClickRight={handleRemoveFromWL} onClickLeft={setCurrentStock} demoState={demoState} demo={demo} increaseDemoState={increaseDemoState} />
        </Box>
        /* <Stack direction="column" sx={{ width: { xs: '100%', md: '40%' } }}>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Typography>Transactions</Typography>
                <IconButton
                    aria-label="reset"
                    size="small"
                    onClick={() => {
                        setItemData(null);
                    }}
                >
                    <UndoOutlinedIcon fontSize="small" />
                </IconButton>
            </Box>
            <pre>
                {itemData ? JSON.stringify(itemData, null, 2) : '// The data will appear here'}
            </pre>
        </Stack> */
        // </Stack>
    );
}

export default PortfolioPieChart;